import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";

export default class extends Controller {
  static targets = ["nameFilter", "emailFilter", "companyFilter", "phoneFilter"];

  connect() {
    const tableElement = $("#agents-table");

    this.dataTable = tableElement.DataTable({
      pageLength: 10,
      lengthMenu: [5, 10, 25, 50],
      order: [[0, "asc"]], // ID column by default
      dom:
        "<'row mb-3'<'col-sm-4'l><'col-sm-4'><'col-sm-4'f>>" +
        "<'row'<'col-12'tr>>" +
        "<'row mt-3'<'col-sm-5'i><'col-sm-7'p>>",
      language: { searchPlaceholder: "Search agents...", search: "" }
    });

    // Custom filtering
    $.fn.dataTable.ext.search.push((settings, data, dataIndex) => {
      if (settings.nTable !== tableElement[0]) return true;

      const rowName = data[1].toLowerCase();
      const rowEmail = data[2].toLowerCase();
      const rowCompany = data[3].toLowerCase();
      const rowPhone = data[4].toLowerCase();

      const nameFilter = this.nameFilterTarget.value.toLowerCase();
      const emailFilter = this.emailFilterTarget.value.toLowerCase();
      const companyFilter = this.companyFilterTarget.value.toLowerCase();
      const phoneFilter = this.phoneFilterTarget.value.toLowerCase();

      if (nameFilter && !rowName.includes(nameFilter)) return false;
      if (emailFilter && !rowEmail.includes(emailFilter)) return false;
      if (companyFilter && !rowCompany.includes(companyFilter)) return false;
      if (phoneFilter && !rowPhone.includes(phoneFilter)) return false;

      return true;
    });

    // Listeners
    this.nameFilterTarget.addEventListener("keyup", () => this.refresh());
    this.emailFilterTarget.addEventListener("keyup", () => this.refresh());
    this.companyFilterTarget.addEventListener("keyup", () => this.refresh());
    this.phoneFilterTarget.addEventListener("keyup", () => this.refresh());

    // Listen for Turbo Stream appended rows
    this.element.addEventListener("turbo:append", (event) => {
      if (event.target.closest("#agents_list")) {
        this.dataTable.rows().invalidate().draw();
      }
    });
  }

  refresh() {
    this.dataTable.draw();
  }

  clearFilters() {
    this.nameFilterTarget.value = "";
    this.emailFilterTarget.value = "";
    this.companyFilterTarget.value = "";
    this.phoneFilterTarget.value = "";
    this.dataTable.search("");
    this.dataTable.draw();
  }
}
